import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DireccionModel } from '../ciudadanos/models/direccion.model';
import { SsoService } from '../sso/sso.service';
import { AuditoriaModel } from '../auditoria/models/auditoria.model';
import { Accion } from '../auditoria/models/accion.model';
import { AuditoriaService } from '../auditoria/auditoria.service';

@Injectable({
  providedIn: 'root'
})
export class DireccionService {
  private urlApi = this.ssoService.getTicket().UrlApi;
  private usuario = this.ssoService.getTicket().Usuario.Email;
  private auditoria: AuditoriaModel = new AuditoriaModel(this.usuario, 0);

  constructor(private ssoService: SsoService, private http: HttpClient, private auditoriaService: AuditoriaService) { }

  async saveDireccion(direccion: DireccionModel): Promise<DireccionModel> {
    let response: DireccionModel = new DireccionModel();

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    try{
      response = await this.http.post<DireccionModel>(
        this.urlApi + '/api/ciudadano/direccion/add',
        JSON.stringify(direccion),
        httpOptions
      ).toPromise();

      this.auditoria.AccionId = Accion.CREAR_DIRECCION;
      this.auditoria.Info = 'ID direccion: ' + direccion.id;
      this.auditoriaService.addAuditoria(this.auditoria);
    }catch(e){
      response = null;
    }
    return response;
  }

  async deleteDireccion(direccion: DireccionModel) {
    let response = false;

    try {
      await this.http.delete(
        this.urlApi + '/api/ciudadano/direccion/del?id=' + direccion.id
      ).toPromise().then(
        res => {
          response = true;

          this.auditoria.AccionId = Accion.BORRAR_DIRECCION;
          this.auditoria.Info = 'ID direccion: ' + direccion.id;
          this.auditoriaService.addAuditoria(this.auditoria);
        }, error => {
          response = false;
        }
      );
    } catch (e) {
      response = false;
    }
    return response;
  }
}
